import React, { useContext, useEffect, useRef } from "react";
import { CountContext } from "../Context/DataCount";
import { useLocation } from "react-router-dom";

const AppWrapper = (props) => {
  const UserRole = localStorage.getItem("UserRole");
  const UserToken = localStorage.getItem("UserToken");
  const { getCountHandler, getAllocationCountHandler, getCBTCount } =
    useContext(CountContext);
  const location = useLocation();
  const fetchedRole = useRef(null);

  useEffect(() => {
    if (UserRole && fetchedRole.current !== UserRole) {
      fetchedRole.current = UserRole;
      if (UserRole === "StockManager") {
        allocationCountApi();
      } else if (UserRole === "ShowroomManager") {
        countData();
      }
    }
  }, [UserRole]);

  const countData = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", global.authToken);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      UserToken: UserToken,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${global.apiBaseUrl}/api/v1/stockone/srm/BookingCountApi`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status_code == 200 && result.status == "Success") {
          getCountHandler(result);
        }
      })
      .catch((error) => console.log("error", error));
  };

  const allocationCountApi = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", global.authToken);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      UserToken: UserToken,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${global.apiBaseUrl}/api/v1/stockone/am/AMMenuCount`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status_code === 200 && result.status === "Success") {
          getAllocationCountHandler(result);
        }
      })
      .catch((error) => console.log("error", error));
  };


  return <div>{props.children}</div>;
};

export default AppWrapper;
